var React = require('react');

function IconTextSearch (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#9e9e9e","d":"M8 9.692H2V7.231h6zm0 3.692H2v2.462h6zM24.308 22l-4.6-4.714a5.937 5.937 0 0 1-3.308 1.022 6.081 6.081 0 0 1-6-6.154 6 6 0 1 1 12 0 6.24 6.24 0 0 1-1 3.385l4.6 4.726zM20 12.154a3.6 3.6 0 1 0-3.6 3.692 3.658 3.658 0 0 0 3.6-3.692zM2 22h12v-2.462H2z","transform":"translate(-2 -2)"}))]);
}

IconTextSearch.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconTextSearch;

IconTextSearch.default = IconTextSearch;
